import { Heading } from '../../common/form/form-parts';
import { Button } from 'tradera/components/atoms/button/button';
import { FormFooterLogo } from 'tradera/apps/registration/components/common/form/form-footer-logo';

export const SwedishPrivateFormAccountCreatedWithProvider = (props) => {
    const {
        isNativeAppContext,
        helpUrl,
        firstName,
        redirectLink,
        provider,
        providerName,
        userIcon
    } = props;

    const header =
        providerName == 'None'
            ? 'Du kan nu logga in på Tradera'
            : `Du kan nu logga in med ${providerName} på Tradera`;
    return (
        <>
            <div />
            <div className={'mt-7'}>
                <div className={'text-center'}>{userIcon}</div>
                <Heading>{firstName ? `Hej ${firstName}!` : `Hej!`}</Heading>
                <div className="text-center">{header}</div>
                <Button
                    theme="primary"
                    fluid
                    className="my-3"
                    href={
                        isNativeAppContext
                            ? `tradera://login/${provider}`
                            : redirectLink || '/'
                    }>
                    {isNativeAppContext ? 'Fortsätt' : 'Gå till Tradera'}
                </Button>
                <div className={'text-center mb-3'}>
                    Har du problem? <a href={helpUrl}>Kontakta oss</a>
                </div>
            </div>
            <div className="text-center mb-4">
                <FormFooterLogo />
            </div>
        </>
    );
};
